import type { ReactNode } from "react";
import { cn } from "../../utils/classMerger";

interface WizardStepProps {
    children: ReactNode;
    isActive: boolean;
    className?: string;
}

export default function WizardStep({
    children,
    isActive,
    className,
}: WizardStepProps) {
    if (!isActive) return null;

    return <div className={cn("space-y-6", className)}>{children}</div>;
}
